module.exports = __webpack_public_path__ + "static/media/0002.3394e337.jpg";